import type {
  ParkEnterpriseClaimStatus,
  ParkEnterpriseInvitationStatus,
  ParkEnterpriseSource,
  ParkEnterpriseStage,
  ParkEnterpriseType,
} from '@/services/bff/types/enterprise-library';

export const STAGE_TEXT: Record<ParkEnterpriseStage, string> = {
  prospect: '潜在企业',
  applying: '入驻申请中',
  pending_entry: '待入驻',
  active: '在园',
  exiting: '迁出中',
  exited: '已迁出',
};

export const enterpriseStatusText = (
  stage: ParkEnterpriseStage,
  enterpriseType: ParkEnterpriseType,
) =>
  stage === 'active' && enterpriseType === 'incubating'
    ? '孵化'
    : stage === 'exited'
      ? '迁出'
      : STAGE_TEXT[stage];

export const CLAIM_TEXT: Record<ParkEnterpriseClaimStatus, string> = {
  unclaimed: '未认领',
  pending_review: '待审核',
  claimed: '已认领',
};

export const SOURCE_TEXT: Record<ParkEnterpriseSource, string> = {
  manual: '手工新增',
  import: '批量导入',
  application: '企业主动申请',
  invitation: '园区邀请',
  sync: '外部同步',
};

export const INVITATION_TEXT: Record<ParkEnterpriseInvitationStatus, string> = {
  active: '已生成',
  accepted: '已接受',
  expired: '已失效',
  cancelled: '已取消',
  rejected_by_enterprise: '企业已拒绝',
};

export const MANUAL_STAGES: ParkEnterpriseStage[] = [
  'prospect',
  'pending_entry',
  'active',
  'exited',
];

export const displayText = (value?: string | null) => value?.trim() || '-';
